import { Provider } from './provider';

export class ProviderLoadbee extends Provider {
    private static payload = {
        ref: window.location.href,
    };

    public getAvailabilitySource(): string {
        const payloadQuery = ProviderLoadbee.getPayloadQuery();
        return `https://availability.loadbee.com/v3/EAN/${this.ean}/de_DE?template=default&apiKey=YtsabDhhTZBSLN6TPSRhFpW37XbwUTeH&__integration=v2021-02-08&${payloadQuery}`;
    }
    public isContentAvailable(parsedAvailabilityResponse: Record<string, string>): boolean {
        return parsedAvailabilityResponse.status === 'ok';
    }

    public createIframeSrc(parsedAvailabilityResponse: Record<string, string>): string {
        return parsedAvailabilityResponse.url;
    }

    private static getPayloadQuery() {
        const payload = window.btoa(JSON.stringify(this.payload));
        return 'payload=' + payload.replace(/\//g, '_').replace(/\+/g, '-').replace(/(=+)$/, '');
    }
}
